export const translations = {
  fr: {
    common: {
      brand: 'E-Central',
      brandSub: 'par La Centrale',
      langCode: 'FR',
    },
    nav: {
      home: 'Accueil',
      services: 'Services',
      advantages: 'Avantages',
      process: 'Processus',
      faq: 'FAQ',
      contact: 'Contact',
      ctaHeader: 'Parler à un conseiller',
    },
    hero: {
      label: 'Service E-Gestionnaire pour centres d’hébergement',
      title1: 'Reprenez le contrôle',
      title2: 'de votre gestion.',
      title3: 'Libérez du temps pour diriger.',
      subtitle:
        "E-Central accompagne les centres d’hébergement, ressources intermédiaires et milieux sociosanitaires dans leur gestion administrative, clinique et réglementaire afin de réduire la surcharge, structurer les suivis et sécuriser la conformité MSSS / CIUSSS.",
      ctaPrimary: 'Découvrir E-Gestionnaire',
      ctaSecondary: 'Planifier une discussion',
      indicators: [
        'Formation des gestionnaires',
        'Soutien MSSS / CIUSSS',
        'Accompagnement externe sans lien d’emploi',
      ],
      imageAlt: 'Équipe de gestionnaires en réunion professionnelle',
    },
    problem: {
      eyebrow: 'Le constat',
      title: 'Votre gestion ne devrait pas reposer sur l’urgence permanente.',
      body:
        "Manque de temps, pression réglementaire, communications complexes avec le CIUSSS, audits, documents à produire, incidents, allégations, décès, roulement de personnel : les gestionnaires de centres d’hébergement doivent tout porter à la fois.",
      cards: [
        { title: 'Gestion du personnel', desc: 'Horaires, suivis, encadrement et soutien des équipes au quotidien.' },
        { title: 'Situations cliniques sensibles', desc: 'Incidents, allégations, décès, événements indésirables à gérer avec rigueur.' },
        { title: 'Exigences administratives', desc: 'Documents, registres, procédures et rapports à produire en continu.' },
        { title: 'Conformité MSSS / CIUSSS', desc: 'Audits, demandes, rencontres et obligations réglementaires à respecter.' },
      ],
      closing: 'Quand tout devient prioritaire, il devient difficile de diriger avec clarté.',
    },
    solution: {
      eyebrow: 'La solution',
      title: 'E-Gestionnaire : un partenaire externe pour structurer votre gestion.',
      body:
        "E-Gestionnaire est un service d’accompagnement, de formation et de soutien opérationnel conçu pour les gestionnaires de centres d’hébergement, RI et RPA. Notre rôle : vous aider à sortir du mode réaction, clarifier vos processus et renforcer votre conformité.",
      cards: [
        {
          title: 'Formation du personnel de gestion',
          desc: 'Former les gestionnaires désignés à comprendre les obligations, appliquer les procédures et mieux encadrer les équipes.',
        },
        {
          title: 'Accompagnement continu',
          desc: 'Soutenir vos suivis administratifs, cliniques et opérationnels avec une approche structurée et réaliste.',
        },
        {
          title: 'Soutien à la conformité',
          desc: 'Aider à respecter les exigences MSSS / CIUSSS, préparer les audits, organiser les documents et répondre aux demandes de l’établissement.',
        },
      ],
    },
    services: {
      eyebrow: 'Services concrets',
      title: 'Ce que E-Central peut prendre en charge avec vous.',
      items: [
        { title: 'Formation E-Gestionnaire à distance', desc: 'Sessions structurées pour vos gestionnaires, accessibles à distance et adaptées à votre réalité.' },
        { title: 'Préparation et suivi des rencontres CIUSSS / CISSS', desc: 'Préparer les ordres du jour, structurer les suivis et documenter les engagements.' },
        { title: 'Grilles de classification et suivis requis', desc: 'Soutien à la production, à la révision et au suivi des grilles obligatoires.' },
        { title: 'MAES et demandes de remboursement', desc: 'Accompagnement dans les démarches MAES et les demandes de remboursement liées aux services.' },
        { title: 'Procédures, protocoles et documentation', desc: 'Bâtir, mettre à jour et organiser les documents requis pour votre centre.' },
        { title: 'Supervision des outils de gestion', desc: 'Soutien dans l’utilisation d’Agendrix, Outlook, Teams ou outils équivalents.' },
      ],
    },
    advantages: {
      eyebrow: 'Avantages',
      title: 'Des bénéfices concrets pour vos gestionnaires.',
      items: [
        'Libérer du temps pour les décisions importantes',
        'Réduire les erreurs et les oublis',
        'Structurer les suivis avec plus de clarté',
        'Mieux répondre aux demandes du CIUSSS / CISSS',
        'Préparer les audits avec moins de stress',
        'Soutenir les équipes dans les situations sensibles',
        'Reprendre un vrai rôle de direction',
        'Sécuriser la qualité des services sans alourdir vos équipes',
      ],
      cta: 'Je veux alléger ma gestion',
    },
    approach: {
      eyebrow: 'Notre approche',
      title: 'Une approche humaine, rigoureuse et réaliste.',
      body:
        "E-Central comprend la réalité du terrain. Chaque centre est différent, mais les exigences demeurent élevées. Notre accompagnement repose sur des outils concrets, des procédures applicables, une collaboration respectueuse avec vos équipes et une vision humaine de la gestion.",
      pillars: [
        { title: 'Écoute du terrain', desc: 'Comprendre votre quotidien avant de proposer des solutions.' },
        { title: 'Procédures applicables', desc: 'Des outils réalistes, conçus pour être réellement utilisés.' },
        { title: 'Collaboration avec vos équipes', desc: 'Un soutien respectueux qui valorise vos gestionnaires.' },
        { title: 'Rigueur réglementaire', desc: 'Une exigence constante face aux obligations MSSS / CIUSSS.' },
      ],
    },
    process: {
      eyebrow: 'Processus',
      title: 'Comment fonctionne l’accompagnement E-Gestionnaire ?',
      steps: [
        { title: 'Analyse de votre réalité', desc: 'Nous identifions vos urgences, vos obligations et vos points de friction.' },
        { title: 'Structuration des priorités', desc: 'Nous clarifions les suivis, les responsabilités, les documents et les échéances.' },
        { title: 'Formation et accompagnement', desc: 'Nous outillons vos gestionnaires et accompagnons l’application des procédures.' },
        { title: 'Suivi continu', desc: 'Nous soutenons les communications, les rencontres, les documents et la conformité.' },
      ],
    },
    audience: {
      eyebrow: 'Pour qui',
      title: 'Pour quels milieux ?',
      items: [
        { title: 'Ressources intermédiaires (RI)', desc: 'Soutien à la gestion, aux suivis cliniques et aux rapports requis.' },
        { title: 'Centres d’hébergement', desc: 'Encadrement administratif, conformité et structuration des opérations.' },
        { title: 'Résidences privées pour aînés (RPA)', desc: 'Accompagnement réglementaire et soutien opérationnel adapté.' },
        { title: 'Organismes sociosanitaires', desc: 'Soutien à la gouvernance, à la documentation et à la gestion des équipes.' },
        { title: 'Gestionnaires de ressources d’hébergement', desc: 'Coaching, structuration des suivis et formation continue.' },
        { title: 'Directions d’établissements partenaires', desc: 'Soutien aux directions privées ou partenaires du réseau public.' },
      ],
    },
    stats: {
      title: 'Une approche centrée sur trois axes.',
      items: [
        { value: '3 axes', label: 'Formation · Gestion · Conformité' },
        { value: '100 %', label: 'Orienté terrain' },
        { value: '1 partenaire', label: 'Externe pour alléger votre charge' },
        { value: '0 lien', label: 'D’emploi avec vos équipes internes' },
      ],
      footnote: 'Approche orientée terrain · soutien structuré · accompagnement adapté.',
    },
    testimonials: {
      eyebrow: 'Témoignages',
      title: 'Ce que disent les milieux que nous accompagnons.',
      disclaimer: 'Exemples illustratifs de retours typiques rencontrés sur le terrain.',
      items: [
        { quote: 'E-Central nous a aidés à clarifier nos suivis et à mieux préparer nos rencontres.', author: 'Gestionnaire', role: 'Ressource intermédiaire' },
        { quote: 'Nous avons gagné en structure sans alourdir notre équipe.', author: 'Direction', role: 'Centre d’hébergement' },
        { quote: 'L’accompagnement nous a permis de mieux comprendre nos obligations et de mieux encadrer nos procédures.', author: 'Responsable clinique', role: 'RI / RPA' },
      ],
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Questions fréquentes.',
      items: [
        { q: 'Est-ce que E-Gestionnaire remplace notre direction ?', a: 'Non. Le service soutient vos gestionnaires, structure vos suivis et vous aide à reprendre le contrôle, sans remplacer votre rôle de direction.' },
        { q: 'Est-ce que le service est offert à distance ?', a: 'Oui. Une grande partie de l’accompagnement peut se faire à distance, avec des interventions en présentiel au besoin.' },
        { q: 'Est-ce adapté aux RI et aux RPA ?', a: 'Oui. Le service s’adresse aux ressources intermédiaires, centres d’hébergement, RPA et organismes sociosanitaires.' },
        { q: 'Pouvez-vous soutenir la conformité MSSS / CIUSSS ?', a: 'Oui. E-Central aide à structurer les documents, les suivis, les communications et les préparations liées aux exigences MSSS / CIUSSS.' },
        { q: 'Formez-vous les gestionnaires ?', a: 'Oui. Le service inclut la formation du personnel de gestion désigné par le centre.' },
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Vous sentez que la gestion prend toute la place ?',
      body:
        "Il est possible de faire autrement. Contactez E-Central pour discuter de votre réalité et découvrir comment le service E-Gestionnaire peut soutenir votre centre d’hébergement.",
      email: 'support@e-central.ca',
      hours: 'Réponse rapide les jours ouvrables.',
      form: {
        name: 'Nom',
        organization: 'Organisation',
        facilityType: 'Type de milieu',
        facilityOptions: {
          ri: 'Ressource intermédiaire (RI)',
          rpa: 'Résidence privée pour aînés (RPA)',
          chsld: 'Centre d’hébergement',
          orgsoc: 'Organisme sociosanitaire',
          other: 'Autre',
        },
        email: 'Courriel',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Demander une discussion',
        submitting: 'Envoi en cours…',
        successTitle: 'Demande envoyée',
        successDesc: 'Merci. Nous vous reviendrons rapidement.',
        errorTitle: 'Une erreur est survenue',
        errorDesc: 'Veuillez réessayer ou nous écrire à support@e-central.ca.',
        placeholderName: 'Votre nom complet',
        placeholderOrg: 'Nom de votre organisation',
        placeholderType: 'Sélectionnez un type de milieu',
        placeholderEmail: 'vous@exemple.ca',
        placeholderPhone: '(514) 000-0000',
        placeholderMessage: 'Décrivez brièvement votre situation, vos besoins ou vos questions.',
      },
    },
    footer: {
      tagline:
        "Services de gestion, formation et accompagnement pour centres d’hébergement, RI, RPA et organismes sociosanitaires.",
      quickLinks: 'Liens rapides',
      contact: 'Contact',
      legal: '© ' + new Date().getFullYear() + ' E-Central · La Centrale. Tous droits réservés.',
      privacy: 'Confidentialité',
    },
    cookies: {
      title: 'Respect de votre vie privée',
      body:
        "Conformément à la Loi 25 du Québec, ce site utilise uniquement des cookies essentiels au bon fonctionnement (préférence de langue) et un cookie analytique anonyme. Aucune donnée n’est partagée à des fins publicitaires.",
      accept: 'Tout accepter',
      decline: 'Essentiels seulement',
      learnMore: 'En savoir plus',
    },
    privacy: {
      title: 'Politique de confidentialité',
      lastUpdated: 'Dernière mise à jour',
      backHome: 'Retour à l’accueil',
      sections: [
        {
          h: 'Responsable du traitement',
          p:
            "E-Central / La Centrale est responsable des renseignements personnels recueillis sur ce site. Pour toute question relative à la protection des renseignements personnels au sens de la Loi 25 du Québec, vous pouvez nous joindre à support@e-central.ca.",
        },
        {
          h: 'Renseignements recueillis',
          p:
            "Nous recueillons uniquement les renseignements que vous nous transmettez volontairement via le formulaire de contact : nom, organisation, type de milieu, courriel, téléphone et message. Aucun renseignement sensible n’est demandé.",
        },
        {
          h: 'Finalités',
          p:
            "Ces renseignements servent exclusivement à répondre à votre demande, planifier une discussion et vous transmettre l’information demandée à propos du service E-Gestionnaire. Ils ne sont jamais vendus, loués ou partagés à des fins publicitaires.",
        },
        {
          h: 'Conservation',
          p:
            "Les demandes de contact sont conservées pour la durée nécessaire au suivi commercial et opérationnel, puis détruites sur demande ou après un délai maximal de 24 mois sans activité.",
        },
        {
          h: 'Témoins (cookies)',
          p:
            "Le site utilise un témoin essentiel pour mémoriser votre choix de langue (FR/EN) et un témoin analytique anonyme. Aucun témoin publicitaire ou de suivi inter-sites n’est utilisé.",
        },
        {
          h: 'Vos droits',
          p:
            "Conformément à la Loi 25, vous avez le droit d’accéder à vos renseignements, de les rectifier, d’en demander la suppression ou de retirer votre consentement en tout temps. Écrivez-nous à support@e-central.ca.",
        },
      ],
    },
  },

  en: {
    common: {
      brand: 'E-Central',
      brandSub: 'by La Centrale',
      langCode: 'EN',
    },
    nav: {
      home: 'Home',
      services: 'Services',
      advantages: 'Benefits',
      process: 'Process',
      faq: 'FAQ',
      contact: 'Contact',
      ctaHeader: 'Talk to an advisor',
    },
    hero: {
      label: 'E-Gestionnaire service for residential care facilities',
      title1: 'Take back control',
      title2: 'of your management.',
      title3: 'Free up time to lead.',
      subtitle:
        "E-Central supports residential care facilities, intermediate resources (RI) and sociosanitary organizations in their administrative, clinical and regulatory management to reduce overload, structure follow-ups and secure MSSS / CIUSSS compliance.",
      ctaPrimary: 'Discover E-Gestionnaire',
      ctaSecondary: 'Book a discussion',
      indicators: [
        'Manager training',
        'MSSS / CIUSSS support',
        'External support without employment ties',
      ],
      imageAlt: 'Team of managers in a professional meeting',
    },
    problem: {
      eyebrow: 'The reality',
      title: 'Your management shouldn’t run on permanent emergency.',
      body:
        "Lack of time, regulatory pressure, complex communications with CIUSSS, audits, documents to produce, incidents, allegations, deaths, staff turnover: managers of residential facilities have to carry it all at once.",
      cards: [
        { title: 'Staff management', desc: 'Schedules, follow-ups, supervision and daily team support.' },
        { title: 'Sensitive clinical situations', desc: 'Incidents, allegations, deaths and adverse events to handle with rigor.' },
        { title: 'Administrative requirements', desc: 'Documents, records, procedures and reports to produce continuously.' },
        { title: 'MSSS / CIUSSS compliance', desc: 'Audits, requests, meetings and regulatory obligations to meet.' },
      ],
      closing: 'When everything becomes a priority, it gets harder to lead with clarity.',
    },
    solution: {
      eyebrow: 'The solution',
      title: 'E-Gestionnaire: an external partner to structure your management.',
      body:
        "E-Gestionnaire is a coaching, training and operational support service designed for managers of residential facilities, RI and RPA. Our role: helping you move out of reaction mode, clarify your processes and strengthen your compliance.",
      cards: [
        {
          title: 'Training of management staff',
          desc: 'Train designated managers to understand obligations, apply procedures and better lead teams.',
        },
        {
          title: 'Ongoing support',
          desc: 'Support your administrative, clinical and operational follow-ups with a structured and realistic approach.',
        },
        {
          title: 'Compliance support',
          desc: 'Help meet MSSS / CIUSSS requirements, prepare audits, organize documents and answer institution requests.',
        },
      ],
    },
    services: {
      eyebrow: 'Concrete services',
      title: 'What E-Central can take on with you.',
      items: [
        { title: 'Remote E-Gestionnaire training', desc: 'Structured sessions for your managers, accessible remotely and tailored to your reality.' },
        { title: 'CIUSSS / CISSS meeting preparation', desc: 'Prepare agendas, structure follow-ups and document commitments.' },
        { title: 'Classification grids and required follow-ups', desc: 'Support to produce, review and track mandatory grids.' },
        { title: 'MAES and reimbursement claims', desc: 'Coaching through MAES procedures and reimbursement requests related to services.' },
        { title: 'Procedures, protocols and documentation', desc: 'Build, update and organize the documents required for your facility.' },
        { title: 'Management tools supervision', desc: 'Support in the use of Agendrix, Outlook, Teams or equivalent tools.' },
      ],
    },
    advantages: {
      eyebrow: 'Benefits',
      title: 'Concrete benefits for your managers.',
      items: [
        'Free up time for important decisions',
        'Reduce mistakes and oversights',
        'Structure follow-ups with more clarity',
        'Better respond to CIUSSS / CISSS requests',
        'Prepare audits with less stress',
        'Support teams in sensitive situations',
        'Reclaim a true leadership role',
        'Secure service quality without overloading your teams',
      ],
      cta: 'I want to lighten my management',
    },
    approach: {
      eyebrow: 'Our approach',
      title: 'A human, rigorous and realistic approach.',
      body:
        "E-Central understands the realities on the ground. Every facility is different, but the requirements remain high. Our support relies on concrete tools, applicable procedures, respectful collaboration with your teams and a human view of management.",
      pillars: [
        { title: 'Listening to the field', desc: 'Understand your day-to-day before proposing solutions.' },
        { title: 'Applicable procedures', desc: 'Realistic tools, designed to actually be used.' },
        { title: 'Collaboration with your teams', desc: 'Respectful support that values your managers.' },
        { title: 'Regulatory rigor', desc: 'A constant standard against MSSS / CIUSSS obligations.' },
      ],
    },
    process: {
      eyebrow: 'Process',
      title: 'How does the E-Gestionnaire support work?',
      steps: [
        { title: 'Analysis of your reality', desc: 'We identify your urgencies, obligations and friction points.' },
        { title: 'Structuring of priorities', desc: 'We clarify follow-ups, responsibilities, documents and deadlines.' },
        { title: 'Training and coaching', desc: 'We equip your managers and support the application of procedures.' },
        { title: 'Ongoing follow-up', desc: 'We support communications, meetings, documents and compliance.' },
      ],
    },
    audience: {
      eyebrow: 'Who it is for',
      title: 'Which environments?',
      items: [
        { title: 'Intermediate resources (RI)', desc: 'Support for management, clinical follow-ups and required reports.' },
        { title: 'Residential care facilities', desc: 'Administrative oversight, compliance and operational structuring.' },
        { title: 'Private residences for seniors (RPA)', desc: 'Regulatory guidance and tailored operational support.' },
        { title: 'Sociosanitary organizations', desc: 'Support for governance, documentation and team management.' },
        { title: 'Residential facility managers', desc: 'Coaching, structuring of follow-ups and continuous training.' },
        { title: 'Partner facility directors', desc: 'Support for private directors or public network partners.' },
      ],
    },
    stats: {
      title: 'An approach centered on three axes.',
      items: [
        { value: '3 axes', label: 'Training · Management · Compliance' },
        { value: '100 %', label: 'Field-oriented' },
        { value: '1 partner', label: 'External, to lighten your load' },
        { value: '0 ties', label: 'No employment link with your internal teams' },
      ],
      footnote: 'Field-oriented approach · structured support · tailored coaching.',
    },
    testimonials: {
      eyebrow: 'Testimonials',
      title: 'What the facilities we support tell us.',
      disclaimer: 'Illustrative examples of typical feedback encountered on the ground.',
      items: [
        { quote: 'E-Central helped us clarify our follow-ups and better prepare our meetings.', author: 'Manager', role: 'Intermediate resource' },
        { quote: 'We gained structure without overloading our team.', author: 'Director', role: 'Residential facility' },
        { quote: 'The support helped us better understand our obligations and better frame our procedures.', author: 'Clinical lead', role: 'RI / RPA' },
      ],
    },
    faq: {
      eyebrow: 'FAQ',
      title: 'Frequently asked questions.',
      items: [
        { q: 'Does E-Gestionnaire replace our management?', a: 'No. The service supports your managers, structures your follow-ups and helps you regain control, without replacing your leadership role.' },
        { q: 'Is the service offered remotely?', a: 'Yes. A large part of the support can be done remotely, with on-site interventions when needed.' },
        { q: 'Is it adapted to RI and RPA?', a: 'Yes. The service is designed for intermediate resources, residential facilities, RPA and sociosanitary organizations.' },
        { q: 'Can you support MSSS / CIUSSS compliance?', a: 'Yes. E-Central helps structure documents, follow-ups, communications and preparations linked to MSSS / CIUSSS requirements.' },
        { q: 'Do you train managers?', a: 'Yes. The service includes the training of management staff designated by the facility.' },
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Do you feel that management is taking over?',
      body:
        "There is another way. Contact E-Central to discuss your reality and find out how the E-Gestionnaire service can support your residential facility.",
      email: 'support@e-central.ca',
      hours: 'Quick response on business days.',
      form: {
        name: 'Name',
        organization: 'Organization',
        facilityType: 'Facility type',
        facilityOptions: {
          ri: 'Intermediate resource (RI)',
          rpa: 'Private residence for seniors (RPA)',
          chsld: 'Residential facility',
          orgsoc: 'Sociosanitary organization',
          other: 'Other',
        },
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Request a discussion',
        submitting: 'Sending…',
        successTitle: 'Request sent',
        successDesc: 'Thank you. We will get back to you quickly.',
        errorTitle: 'An error occurred',
        errorDesc: 'Please try again or email us at support@e-central.ca.',
        placeholderName: 'Your full name',
        placeholderOrg: 'Your organization name',
        placeholderType: 'Select a facility type',
        placeholderEmail: 'you@example.com',
        placeholderPhone: '(514) 000-0000',
        placeholderMessage: 'Briefly describe your situation, needs or questions.',
      },
    },
    footer: {
      tagline:
        "Management, training and coaching services for residential facilities, RI, RPA and sociosanitary organizations.",
      quickLinks: 'Quick links',
      contact: 'Contact',
      legal: '© ' + new Date().getFullYear() + ' E-Central · La Centrale. All rights reserved.',
      privacy: 'Privacy',
    },
    cookies: {
      title: 'Respect for your privacy',
      body:
        "In accordance with Québec's Law 25, this site only uses essential cookies for proper functioning (language preference) and one anonymous analytics cookie. No data is shared for advertising purposes.",
      accept: 'Accept all',
      decline: 'Essentials only',
      learnMore: 'Learn more',
    },
    privacy: {
      title: 'Privacy policy',
      lastUpdated: 'Last updated',
      backHome: 'Back to home',
      sections: [
        {
          h: 'Data controller',
          p:
            "E-Central / La Centrale is responsible for the personal information collected on this site. For any question related to the protection of personal information under Québec's Law 25, you may contact us at support@e-central.ca.",
        },
        {
          h: 'Information collected',
          p:
            "We only collect the information you voluntarily provide via the contact form: name, organization, facility type, email, phone and message. No sensitive information is requested.",
        },
        {
          h: 'Purposes',
          p:
            "This information is used solely to respond to your request, schedule a discussion and provide the requested information about the E-Gestionnaire service. It is never sold, rented or shared for advertising purposes.",
        },
        {
          h: 'Retention',
          p:
            "Contact requests are kept for the time required for commercial and operational follow-up, then deleted on request or after a maximum period of 24 months without activity.",
        },
        {
          h: 'Cookies',
          p:
            "The site uses one essential cookie to remember your language choice (FR/EN) and one anonymous analytics cookie. No advertising or cross-site tracking cookie is used.",
        },
        {
          h: 'Your rights',
          p:
            "In accordance with Law 25, you have the right to access your information, correct it, request its deletion or withdraw your consent at any time. Email us at support@e-central.ca.",
        },
      ],
    },
  },
};
